// Indian rupee formatting, used everywhere money is shown.
//
// Two things the default toLocaleString() got wrong here: grouping and paise.
// India groups by 2s after the first 3 digits (1,00,000 not 100,000), and a
// contribution of exactly 2000 should read "₹2,000", not "₹2000.00".

const WHOLE = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const WITH_PAISE = new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: 'INR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// ₹2,000 for round amounts, ₹1,187.50 when paise actually matter
export const formatINR = (value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '₹0';
  return Number.isInteger(amount) ? WHOLE.format(amount) : WITH_PAISE.format(amount);
};

// Always whole rupees - for headline figures and axis labels
export const formatINRWhole = (value) => {
  const amount = Number(value);
  return WHOLE.format(Number.isFinite(amount) ? amount : 0);
};

// Compact form for tight spaces: ₹1.2L, ₹15.5K
export const formatINRCompact = (value) => {
  const amount = Number(value) || 0;
  const abs = Math.abs(amount);
  if (abs >= 10000000) return `₹${(amount / 10000000).toFixed(2).replace(/\.00$/, '')}Cr`;
  if (abs >= 100000) return `₹${(amount / 100000).toFixed(2).replace(/\.00$/, '')}L`;
  if (abs >= 1000) return `₹${(amount / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  return WHOLE.format(amount);
};

export default formatINR;
